import BnSnStocksPage from "./BnSnStocksPage";

export default function SnStocks() {
  return (
    <BnSnStocksPage
      desk="sn"
      title="SENSEX STOCKS MARKET REACTION"
      gridTitle="Live Sensex Weightage Grid"
      activeTab="sensex"
    />
  );
}
